export enum eDays {
SUNDAY,
MONDAY,
TUESDAY,
WEDNESDAY,
THURSDAY,
FRIDAY,
SATURDAY
}

export const daysLetters = ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ש'"]

export const daysHebrew = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"]